import DoubleArcGauge from "../../../../components/echarts/double-arc-gauge.jsx";

const DutyDispatchEngage = ({data, className = "", height = "100%"}) => {
    const numericData = Number(data) || 0;
    const metric = numericData >= 86400
        ? {value: Math.floor(numericData / 86400), label: "Dias"}
        : numericData >= 3600
            ? {value: Math.floor(numericData / 3600), label: "Horas"}
            : numericData >= 60
                ? {value: Math.floor(numericData / 60), label: "Min"}
                : {value: Math.floor(Math.max(numericData, 0)), label: "Seg"};

    return (
        <section
            className={["flex min-h-0 items-center", className].filter(Boolean).join(" ")}
            style={{height}}
        >
            <DoubleArcGauge
                value={metric.value}
                max={metric.value || 1}
                label={metric.label}
                className="w-[45%] shrink-0"
                labelOffsetCenter="40%"
                labelFontSize={14}
            />

            <h3 className="flex-1 text-start text-(length:--font-md)! 2xl:text-(length:--font-lg)! font-normal! leading-tight text-[#AAAAAA]">
                Tempo médio<br/>
                dos despachos<br/>
                em curso
            </h3>
        </section>
    );
};

export default DutyDispatchEngage;
